import React, { useEffect, useState } from 'react'
import HistoryTable from './HistoryTable'
import "./styles/TransactionHistory.css";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FaChevronLeft } from 'react-icons/fa6';
import noRecordsImg from "../assets/images/no-record-found 3.png";

function TransactionHistory({ agent: propAgent }) {
    const location = useLocation();
    const navigate = useNavigate();
    
    // Get agent from props or location state
    const agent = propAgent || location.state?.agent;

    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 10;

    useEffect(() => {
        setTimeout(() => {
            if (agent) {
                console.log('Agent data for agent wallet transactions:', agent);
                
                // Extract agent wallet transactions from the nested structure
                let agentTransactions = [];
                
                // Check for agent wallet transactions
                if (agent.agent_wallet_details?.recent_transactions) {
                    agentTransactions = agent.agent_wallet_details.recent_transactions;
                    console.log('Found agent wallet transactions:', agentTransactions);
                } 
                // Check for agent details transactions
                else if (agent.agent_details?.recent_transactions) {
                    agentTransactions = agent.agent_details.recent_transactions;
                    console.log('Found agent details transactions:', agentTransactions);
                }
                // Check for direct agent transactions
                else if (agent.mtransactions) {
                    agentTransactions = agent.mtransactions;
                    console.log('Found mtransactions:', agentTransactions);
                }

                // Format transactions for the table
                const formattedTransactions = agentTransactions.map((transaction, index) => ({
                    id: transaction.id || `agent-txn-${index + 1}`,
                    name: transaction.description || transaction.name || 'Commission',
                    earnedDate: transaction.date || 
                               (transaction.created_at ? new Date(transaction.created_at).toLocaleDateString() : 
                               (transaction.earned_date ? new Date(transaction.earned_date).toLocaleDateString() : 'N/A')),
                    topcoin: transaction.amount || transaction.topcoin || '0'
                }));

                console.log('Formatted agent transactions:', formattedTransactions);
                setTransactions(formattedTransactions);
            }
            setLoading(false);
        }, 300);
    }, [agent]);

    const columns = [
        { label: "ID", field: "id" },
        { label: "Description", field: "name" },
        { label: "Date", field: "earnedDate" },
        { label: "Commission", field: "topcoin" },
    ];

    const totalPages = Math.ceil(transactions.length / rowsPerPage);
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentTransactions = transactions.slice(indexOfFirstRow, indexOfLastRow);

    if (!agent) return <p>No agent data available.</p>;

    return (
        <div className="transaction-container">
            <div className="transaction-header">
                <h2 className="title">Advertising Agent Wallet Transaction History</h2>
                <div className="transaction-count">
                    {transactions.length} {transactions.length === 1 ? "Transaction" : "Transactions"}
                </div>
            </div>

            <div className="transaction-content">
                {loading ? (
                    <div className="loading-container">
                        <div className="loading-spinner"></div>
                        <p>Loading agent transactions...</p>
                    </div>
                ) : transactions.length > 0 ? (
                    <HistoryTable
                        columns={columns}
                        data={transactions}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        rowsPerPage={rowsPerPage}
                    />
                ) : (
                    <div className="no-records">
                        <img src={noRecordsImg} alt="No records" />
                        <h3>No commission transactions yet</h3>
                        <p>Commission transactions will appear here when you earn commissions from referrals.</p>
                    </div>
                )}
            </div>

            {transactions.length > 0 && (
                <div className="transaction-pagination">
                    <button 
                        className="page-btn" 
                        onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                        disabled={currentPage === 1}
                    >
                        &lt;
                    </button>
                    {Array.from({ length: totalPages }, (_, i) => (
                        <button
                            key={i}
                            className={`page-btn ${currentPage === i + 1 ? "active" : ""}`}
                            onClick={() => setCurrentPage(i + 1)}
                        >
                            {i + 1}
                        </button>
                    ))}
                    <button 
                        className="page-btn" 
                        onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
                        disabled={currentPage === totalPages}
                    >
                        &gt;
                    </button>
                </div>
            )}

            <div className="back-link">
                <Link to="/advertising-agent-wallet-details" state={{ agent }}>Back to Wallet &lt;&lt;</Link>
            </div>
        </div>
    )
}

export default TransactionHistory